import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/domains/providers/components/provider-games/index.tsx");
